import request from '../services/request';
import { PATH } from './path';
// 数据库列表
export const requestDBList = async params => {
  return request({
    url: PATH.dataQuery.dbList,
    params
  });
};
// 数据表列表
export const requestDBTables = async params => {
  return request({
    url: PATH.dataQuery.dbTables,
    method: 'get',
    params
  });
};
// 表详情
export const requestTableDetail = async params => {
  return request({
    url: PATH.dataQuery.tableDetail,
    method: 'get',
    params
  });
};
// sql详情
export const requestSqlDetail = async params => {
  return request({
    url: PATH.dataQuery.sqlDetail,
    method: 'get',
    params
  });
};
// 运行任务
export const requestRunSql = async data => {
  return request({
    url: PATH.dataQuery.runsql,
    method: 'POST',
    data
  });
};
// 查询执行状态
export const requestCheckTaskStatus = async data => {
  return request({
    url: PATH.dataQuery.checkTaskStatus,
    method: 'POST',
    data
  });
};
// 取消任务
export const requestCancelTask = async data => {
  return request({
    url: PATH.dataQuery.cancelTask,
    method: 'POST',
    data
  });
};

// 保存sql
export const requestSaveSql = async data => {
  return request({
    url: PATH.dataQuery.saveSql,
    method: 'POST',
    data
  });
};
// 获取bucket地址
export const requestGetBucket = async params => {
  return request({
    url: PATH.dataQuery.getBucketAddr,
    method: 'get',
    params
  });
};
// 设置bucket地址
export const requestSetBucket = async data => {
  return request({
    url: PATH.dataQuery.setBucket,
    method: 'POST',
    data
  });
};
// 获取运行结果
export const requestTaskData = async params => {
  return request({
    url: PATH.dataQuery.getTaskData,
    method: 'get',
    params
  });
};

// 删除path
export const requestDelPath = async params => {
  return request({
    url: PATH.dataQuery.delPath,
    method: 'get',
    params
  });
};
